import ButtonLink from '@/components/base/ButtonLink';
import { ctaImage } from '@/mocks/site';

export default function FinalCta() {
  return (
    <section className="relative h-[480px] md:h-[640px] w-full overflow-hidden tone-taupe">
      <img src={ctaImage} alt="Sunlit rendered exterior wall with long afternoon shadows" loading="lazy" className="absolute inset-0 w-full h-full object-cover object-center" />
      <div className="absolute inset-0 cta-fade" />
      <div className="relative z-10 shell h-full flex flex-col justify-end pb-12 md:pb-16 text-background-50">
        <p className="text-[11px] uppercase tracking-[0.14em] mb-4">06 / Estimates</p>
        <h2 className="display text-[clamp(2rem,4.4vw,4rem)] max-w-[16ch]">Let&apos;s renew your walls.</h2>
        <div className="mt-8">
          <ButtonLink to="/contact" variant="light">Request an estimate</ButtonLink>
        </div>
      </div>
    </section>
  );
}